import { AlertDialogComponent } from '../alert/alert.component';
import { Component } from '@angular/core';
import { DialogCloseReason } from '../base-dialog';

@Component({
  selector: 'alert-options-dialog',
  templateUrl: 'alert-with-options.component.html'
})
export class AlertWithOptionDialogComponent extends AlertDialogComponent {
  optionTitle = '';
  optionChecked = false;

  constructor() {
    super();
  }

  initDialog() {
    super.initDialog();
    this.optionTitle = this.extraData.optionTitle ? this.extraData.optionTitle : 'Don\'t show this again';
  }

  closeAlert() {
    this.close({ reason: DialogCloseReason.OK, data: { checked: this.optionChecked } });
  }
}
